var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3CDBC0",
    points: "512,236 432,156 403.715,184.284 435.431,216 272,216 272,256 435.43,256 403.714,287.715  431.998,315.999 511.996,236.002  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M332.035,316.002v155.926c-0.021,0.025-0.047,0.052-0.071,0.072H112.071 c-0.024-0.021-0.051-0.047-0.071-0.072V40.072c0.021-0.025,0.047-0.051,0.071-0.072h219.893c0.024,0.021,0.05,0.047,0.071,0.072 v115.93h40V40c0-22-18-40-40-40H112C90,0,72,18,72,40v432c0,22,18,40,40,40h220.035c22,0,40-18,40-40V316.002H332.035z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSair);
export default __webpack_public_path__ + "static/media/icon_sair.4abfe30a61745a60e61a41ab4a36c118.svg";
export { ForwardRef as ReactComponent };